// Helper function to check if an item should be included based on roleScopes
const shouldIncludeItem = (item, user, accessControl) => {
  if (!item.enabled || (!item.route && item.scope === 'view')) return false;

  const roleScopes = item.roleScopes || [];

  // Admin can see everything with '' (standard access) or 'adminOnly'
  if (user.access === 'admin') {
    return true;
  }

  // If selfService is true, only show items with 'selfService'
  if ((user.access === 'customer' || user.access === 'account') && accessControl.selfService) {
    return roleScopes.includes('selfService');
  }

  // If selfServiceRole is true, only show items with 'selfServiceRole'
  if (accessControl.selfServiceRole) {
    return roleScopes.includes('selfServiceRole');
  }

  // Otherwise, show all standard access items ('' or empty array)
  return roleScopes.length === 0 || roleScopes.includes('');
};

export default shouldIncludeItem;
